export default {
    when() {
        return document.querySelectorAll('.checkboxes').length > 0;
    },

    mounted() {
        document.querySelectorAll('.checkboxes').forEach((element) => {
            const items = element.querySelectorAll('.checkbox');
            const all = element.querySelector('input[value=all]');

            items.forEach((item) => {
                const input = item.querySelector('input');

                input.addEventListener('change', function () {
                    if (this.value === 'all' && this.checked) {
                        items.forEach((tmp) => tmp.querySelector('input').checked = false);
                    }

                    all.checked = Array.from(items).filter((tmp) => tmp.querySelector('input').checked).length === 0;
                });
            });
        });
    },
};
